import React from 'react';

import { ViewNavItem } from '../components/ViewNavItem';
import { VIEWS } from '../constants';
import { VIEW_TO_PATH } from '../routes';
import { useApp } from '../store/AppContext';

// Échec de la synchro Jira plus récent que le dernier succès, et pas encore masqué.
const jiraEnErreur = (health, dismissedAt) =>
  !!(
    health?.last_error_at &&
    health.last_error_at !== dismissedAt &&
    (!health.last_success_at || health.last_error_at > health.last_success_at)
  );

/* Menu des managers : CRM, planning, administration. */
export default function ManagerNav() {
  const {
    isManager,
    jiraHealthDismissedAt,
    jiraSyncHealth,
    navigate,
    sidebarCollapsed,
    setSelectedClient,
  } = useApp();
  if (!isManager) return null;
  return (
    <>
      {!sidebarCollapsed && <div className="nav-section">CRM</div>}
      <ViewNavItem view={VIEWS.CRM_HOME} icon="ti-home" label="Accueil CRM" />
      <ViewNavItem view={VIEWS.CRM_DEALS} icon="ti-layout-kanban" label="Affaires" />
      <ViewNavItem view={VIEWS.CRM_CONTACTS} icon="ti-address-book" label="Contacts" />
      <ViewNavItem view={VIEWS.CRM_FINANCE} icon="ti-chart-pie" label="Dashboard financier" />
      <ViewNavItem view={VIEWS.CRM_TENDERS} icon="ti-file-search" label="Appels d'offres" />
      {!sidebarCollapsed && <div className="nav-section">Planning</div>}
      <ViewNavItem view={VIEWS.TIMELINE} icon="ti-timeline" label="Timeline" />
      <ViewNavItem
        view={VIEWS.PROJECTS}
        icon="ti-briefcase"
        label="Projets"
        onClick={() => {
          setSelectedClient(null);
          navigate(VIEW_TO_PATH.projets);
        }}
      />
      <ViewNavItem view={VIEWS.TEAM} icon="ti-users" label="Équipe" />
      <ViewNavItem view={VIEWS.TIMESHEETS} icon="ti-clock-hour-4" label="Feuilles d'heures" />
      {!sidebarCollapsed && <div className="nav-section">Admin</div>}
      {sidebarCollapsed && <div className="h-[12px]" />}
      <ViewNavItem
        view={VIEWS.JIRA}
        icon="ti-plug-connected"
        label="Jira"
        alert={jiraEnErreur(jiraSyncHealth, jiraHealthDismissedAt)}
      />
    </>
  );
}
